"use strict";

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var AbstractReportConverter_1 = require("../../conversions/AbstractReportConverter");

var PromotionPerformanceReportHeader_1 = require("../model/PromotionPerformanceReportHeader");
/**
 * Converter for Promotion performance report header.
 * Name of this class serves as "usedConverter" stored in report header (to simply distinguish PPR header from other reports).
 * @author Radek Beran
 */


var PromotionPerformanceReportHeaderConverter =
/*#__PURE__*/
function (_AbstractReportConver) {
  _inherits(PromotionPerformanceReportHeaderConverter, _AbstractReportConver);

  function PromotionPerformanceReportHeaderConverter() {
    _classCallCheck(this, PromotionPerformanceReportHeaderConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceReportHeaderConverter).apply(this, arguments));
  }

  _createClass(PromotionPerformanceReportHeaderConverter, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var promotionIds = conversions.asObjectList(source, 'promotionIds', function (id) {
        return conversions.toClassReferenceId(id);
      });
      var header = new PromotionPerformanceReportHeader_1.PromotionPerformanceReportHeader(source.id, source.root, this.mapToObj(source.rootMapping, conversions), promotionIds, source.completed, source.error, source.filter);
      return header.copy('created', conversions.toDate(source.created));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        id: source.id,
        root: this.ensureInterfaceDataOnly(source.root),
        rootMapping: this.mapToDoc(source.rootMapping, conversions),
        promotionIds: conversions.asObjectArray(source, 'promotionIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        completed: source.completed,
        error: source.error,
        filter: source.filter,
        created: conversions.fromDate(source.created)
      };
    }
  }, {
    key: "ensureInterfaceDataOnly",
    value: function ensureInterfaceDataOnly(node) {
      var _this = this;

      var a = {
        id: node.id,
        parentId: node.parentId,
        children: node.children.map(function (ch) {
          return _this.ensureInterfaceDataOnly(ch);
        }),
        level: node.level
      };
      return a;
    }
  }, {
    key: "mapToObj",
    value: function mapToObj(source, conversions) {
      var map = immutable_1.Map();
      Object.keys(source).forEach(function (key) {
        map = map.set(key, source[key]);
      });
      return map;
    }
  }, {
    key: "mapToDoc",
    value: function mapToDoc(source, conversions) {
      var doc = {};
      source.forEach(function (val, key) {
        doc = Object.assign(doc, _defineProperty({}, key, val));
      });
      return doc;
    }
  }]);

  return PromotionPerformanceReportHeaderConverter;
}(AbstractReportConverter_1.AbstractReportConverter);

exports.PromotionPerformanceReportHeaderConverter = PromotionPerformanceReportHeaderConverter;